module.exports = __webpack_public_path__ + "img/HZGB01-01.959e37e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB01-01.png
// module id = K+P5
// module chunks = 0